import { render, staticRenderFns } from "./form-switch.vue?vue&type=template&id=fd6dc5f4&"
import script from "./form-switch.vue?vue&type=script&lang=js&"
export * from "./form-switch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports